import { allowedClientUserRoles } from '@mi-front/core';
import { SelectElement } from 'react-hook-form-mui';
import { useIntl } from 'react-intl';
import { UserRoleInfo } from '../UserRoleInfo';

export function UserRoleField() {
  const { formatMessage } = useIntl();

  return (
    <SelectElement
      name="role"
      label={formatMessage({
        id: 'admin.users.roles.label',
        defaultMessage: 'Rol de usuario',
      })}
      fullWidth
      required
      options={allowedClientUserRoles.map((role) => ({
        id: role,
        label: <UserRoleInfo value={role} />,
      }))}
    />
  );
}
